module.exports = __webpack_public_path__ + "static/media/2017-06-23_60.a3cc8a55.JPG";